import React from "react";
import {AxlInput, AxlPanel, AxlPopConfirm, AxlReselect, AxlSelect} from "axl-reactjs-ui";

import styles, * as E from "../../styles";

export default class ParcelComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      numberParcel: 1,
      typeToAdd: '',
      typeError: false,
    }
  }

  handleTypeSelect = (type) => {
    let error = false;
    if (type === '') {
      error = true;
      this.props.setFormError('add_parcel_type', 'Required');
    }
    this.props.setFormError('add_parcel_type', null);
    this.setState({
      typeToAdd: type,
      typeError: error,
    })
  };

  handleAddParcels = (number, type) => {
    if (type === '') {
      this.props.setFormError('add_parcel_type', 'Required');
      return false;
    }
    this.props.addParcel(number, type);
  };

  render() {
    const { handleParcelInput, parcels, removeParcel, parcelTypes, predefinedParcelTypes, getFormError } = this.props;
    const { numberParcel, typeToAdd, typeError } = this.state;
    // Convert parcelType
    const parcelTypeAddMore = [{value: '', name: ''}];
    const parcelTypesList = [...parcelTypes, ...predefinedParcelTypes];
    parcelTypesList.map(type => {
      const typeAddMore = {};
      typeAddMore.name = type.label;
      typeAddMore.value = type.label;

      parcelTypeAddMore.push(typeAddMore);
      return typeAddMore;
    });

    const typeSelectStyles = {...styles.select_2};
    //if (typeError) typeSelectStyles.borderColor = '#ff0000';

    return (<div>
      <AxlPanel.Row>
        <AxlPanel.Col style={styles.col}>
          {parcels.length === 0 && <div style={{borderTop: '1px solid #ccc', marginBottom: '25px'}} />}
          {parcels.map((parcel, index) => {
            const selectedIndex = parcelTypesList.findIndex(option => option.label === parcel.label);
            const selectedValue = parcelTypesList[selectedIndex] || '';

            // Condition to show options
            const isParcelOptionAvailable = !parcel.predefined && parcel.type !== 'bag';

            return <div key={index}>
              <E.Row className="nomar">
                <E.Label>{`Parcel ${index + 1}`}</E.Label>
                {!index && <E.Col><E.Label className="right">{`Total: ${parcels.length}`}</E.Label></E.Col>}
              </E.Row>
              <E.InputGroupContainer>
                <AxlPopConfirm
                  trigger={<E.Remove><E.RemoveIcon /></E.Remove>}
                  titleFormat={<div>{`Are you sure to delete this parcel?`}</div>}
                  textFormat={<div>{parcel.id && `Parcel ID: ${parcel.id}`}</div>}
                  okText={`OK`}
                  onOk={removeParcel(index)}
                  cancelText={`Cancel`}
                  onCancel={() => null}
                />
                <E.Row>
                  <E.Col>
                    <E.Label>{`Parcel Type`}<E.Text_4>{` - required`}</E.Text_4></E.Label>
                    <AxlReselect
                      placeholder={`Select type`}
                      value={selectedValue}
                      error={getFormError("type")}
                      onChange={handleParcelInput(index, "type")}
                      options={parcelTypesList}
                      theme={`main`}
                      name={`type`}
                      showError={false}
                    />
                  </E.Col>
                  <E.Col>
                    <E.Label>{`Parcel ID`}</E.Label>
                    <AxlInput
                      placeholder={``}
                      value={parcel.parcel_id || ''}
                      error={getFormError("parcel_id")}
                      onChange={handleParcelInput(index)}
                      style={styles.input_1}
                      type={`text`}
                      name={`parcel_id`}
                    />
                  </E.Col>
                </E.Row>
                {isParcelOptionAvailable && <div>
                  <E.InputGroupTitle>
                    <E.InputItem style={{width: "77%"}}>
                      <E.Label>{`Parcel dimension`}<E.I>{` (inch)`}</E.I></E.Label>
                    </E.InputItem>
                    <E.InputItem>
                      <E.Label>{`Parcel weight`}</E.Label>
                    </E.InputItem>
                  </E.InputGroupTitle>
                  <E.InputGroup>
                    <E.InputItem>
                      <AxlInput
                        placeholder={`length  _in`}
                        value={parcel.dimensions.length}
                        onChange={handleParcelInput(index)}
                        style={styles.input_1}
                        type={`number`} min={0}
                        name={`dimensions.length`}
                      />
                    </E.InputItem>
                    <E.InputItem>
                      <AxlInput
                        placeholder={`width  _in`}
                        value={parcel.dimensions.width}
                        onChange={handleParcelInput(index)}
                        style={styles.input_1}
                        type={`number`} min={0}
                        name={`dimensions.width`}
                      />
                    </E.InputItem>
                    <E.InputItem>
                      <AxlInput
                        placeholder={`height  _in`}
                        value={parcel.dimensions.height}
                        onChange={handleParcelInput(index)}
                        style={styles.input_1}
                        type={`number`} min={0}
                        name={`dimensions.height`}
                      />
                    </E.InputItem>
                    <E.InputItem>
                      <AxlInput
                        placeholder={`_  lb`}
                        value={parcel.weight.value}
                        onChange={handleParcelInput(index)}
                        style={styles.input_1}
                        type={`number`} min={0}
                        name={`weight.value`}
                      />
                    </E.InputItem>
                  </E.InputGroup>
                </div>}
              </E.InputGroupContainer>
            </div>
          })}
        </AxlPanel.Col>
      </AxlPanel.Row>
      <AxlPanel.Row>
        <E.InputGroupInline>
          <E.AddMore>Add more parcels:  </E.AddMore>
          <E.InputItemInline>
            <E.Label_1>{`Amount`}</E.Label_1>
            <AxlInput
              style={styles.input_4}
              type={`number`}
              min={1}
              defaultValue={1}
              theme={`numberMini`}
              onChange={(v) => this.setState({numberParcel: v.target.value})}
            />
          </E.InputItemInline>
          <E.InputItemInline>
            <E.Label_1>{`Parcel Type`}</E.Label_1>
            <AxlSelect
              options={parcelTypeAddMore}
              theme={`tiny`}
              style={typeSelectStyles}
              name={`add_parcel_type`}
              error={getFormError("add_parcel_type")}
              showError={false}
              onSelect={(value) => this.handleTypeSelect(value)}
            />
          </E.InputItemInline>
          <button style={styles.button_1} onClick={() => this.handleAddParcels(numberParcel, typeToAdd)}>{`Add`}</button>
        </E.InputGroupInline>
      </AxlPanel.Row>
    </div>);
  }
}
